var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRecord = function SvgRecord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "record_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M716.416 838.4H114.112a51.264 51.264 0 0 1-51.2-51.2V326.4c0-28.224 22.976-51.2 51.2-51.2h602.304c28.224 0 51.2 22.976 51.2 51.2v460.8c0 28.224-22.976 51.2-51.2 51.2m-602.24-512v460.8h602.368l-.064-460.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M935.424 800a25.8 25.8 0 0 1-13.184-3.648l-192-115.2a25.6 25.6 0 0 1-12.416-21.952V454.4c0-8.96 4.736-17.344 12.416-21.952l192-115.2a25.6 25.6 0 0 1 38.784 21.952v435.2a25.536 25.536 0 0 1-25.6 25.6m-166.4-155.264 140.8 84.48V384.448l-140.8 84.48zM662.4 400a25.6 25.6 0 1 1-51.2 0 25.6 25.6 0 0 1 51.2 0m-288 352H169.6a25.6 25.6 0 1 1 0-51.2h204.8a25.6 25.6 0 1 1 0 51.2m92.8-425.6a25.54 25.54 0 0 1-19.776-9.344l-65.92-80.256H188.8a25.6 25.6 0 1 1 0-51.2h204.8a25.6 25.6 0 0 1 19.776 9.344l73.6 89.6A25.6 25.6 0 0 1 467.2 326.4"
  })));
};
export default SvgRecord;